import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme";
const imagePlaceholder = `https://via.placeholder.com/1920x400/fff/000`;

const ImageContainer = styled.div`
  height: ${props => props.height};
  width: ${props => props.width};
  background-image: url(${props =>
    props.url === "" ? imagePlaceholder : props.url});
  background-color: ${props => props.backgroundColor};
  background-size: ${props => props.backgroundSize};
  -webkit-background-size: ${props => props.backgroundSize};
  -moz-background-size: ${props => props.backgroundSize};
  -o-background-size: ${props => props.backgroundSize};
  background-position: ${props => props.backgroundPosition};
  background-repeat: ${props => props.backgroundRepeat};
  background-attachment: ${props => props.backgroundAttachment};

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    height: ${props => props.mdHeight};
  }
`;

ImageContainer.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundSize: PropTypes.string,
  backgroundPosition: PropTypes.string,
  backgroundRepeat: PropTypes.string,
  backgroundAttachment: PropTypes.string
};

ImageContainer.defaultProps = {
  height: "auto",
  width: "auto",
  url: imagePlaceholder,
  backgroundColor: theme.colors.white,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "initial"
};

export default ImageContainer;
